export const BASE_URL =
  "https://api.help-on-time.com/api/datacube/";

export const API_TIMEOUT = "30000";
